import { render, staticRenderFns } from "./CheckDriverHistory.vue?vue&type=template&id=426cf542&scoped=true&"
import script from "./CheckDriverHistory.vue?vue&type=script&lang=ts&"
export * from "./CheckDriverHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426cf542",
  null
  
)

export default component.exports